import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import MemberPointsReportLayer from '../components/MemberPointsReportLayer';

const MemberPointsReportPage = () => {
    return (
        <MasterLayout>
            <MemberPointsReportLayer />
        </MasterLayout>
    );
};

export default MemberPointsReportPage;
